/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import {Link} from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import {useSelector} from "react-redux";
import {DropdownTopbarItemToggler} from "../../../../_partials/dropdowns";
import {FormattedMessage} from "react-intl";
import {logUserAction} from '../../../../../utils';
import {pages as P} from '../../../../../app/modules/_common/constants/pages';
import {subjects as S} from '../../../../../app/modules/_common/constants/subjects';
import {actionTypes as T} from '../../../../../app/modules/_common/constants/actionTypes';
import {logMessages as L} from '../../../../../app/modules/_common/constants/logMessages';

export function UserProfileDropdown() {
  const {user} = useSelector((state) => state.auth);

  return (
    <Dropdown drop="down">
      <Dropdown.Toggle
        as={DropdownTopbarItemToggler}
        id="dropdown-toggle-user-profile"
      >
        <div
          className={
            "btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2 custom-user-toggler"
          }
        >
          <span
            className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
            {user.fullName}
          </span>
          <span className="symbol symbol-35 symbol-light-success">
            <span className="symbol-label font-size-h5 font-weight-bold">
              {user.initials}
            </span>
          </span>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu
        menuAlign="left"
        className="w-auto p-0 m-0 dropdown-menu-left dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl"
      >
        <div className="p-5">
          <Link
            to="/logout"
            className="nav-link bg-hover-primary-o-9 text-hover-white text-primary font-weight-bold rounded"
            onClick={() => {
              logUserAction(
                P.AUTH,
                S.SYSTEM_ACCESS,
                T.CREATE,
                L.LOGOUT(user.username),
                0
              );
            }}
          >
            <FormattedMessage
              id="userInfo-btn-logout"
              defaultMessage="Logout"
            />
          </Link>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
